import CommissionPlanEditorContainer from './container';
import { useLazyQuery, useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { CREATE_PLAN, UPDATE_PLAN, QUERY_CHECK_DEFAULT_PLAN, QUERY_CHECK_NAME } from '../queries';
import React, { useEffect, useRef } from 'react';

const CommissionPlanEditor = ({ modalType, editPlan, handleCloseModal }) => {
  const { t } = useTranslation();
  const queryNamePromiseRef = useRef(null);
  const queryCheckDefaultPlanPromiseRef = useRef(null);
  const [createPlan] = useMutation(CREATE_PLAN);
  const [updatePlan] = useMutation(UPDATE_PLAN);
  const [
    queryCheckDefaultPlan,
    {
      data: checkDefaultPlanData,
      error: checkDefaultPlanQueryError,
      loading: checkDefaultPlanQueryLoading,
    },
  ] = useLazyQuery(QUERY_CHECK_DEFAULT_PLAN, { fetchPolicy: 'no-cache' });

  const [
    queryDuplicateName,
    { data: checkNameData, error: checkNameQueryError, loading: checkNameQueryLoading },
  ] = useLazyQuery(QUERY_CHECK_NAME, {
    fetchPolicy: 'no-cache',
  });

  const queryDuplicateNamePromise = name =>
    new Promise((resolve, reject) => {
      queryNamePromiseRef.current = { resolve, reject };
      queryDuplicateName({ variables: { name } });
    });

  const queryCheckDefaultPlanPromise = countryCode =>
    new Promise((resolve, reject) => {
      queryCheckDefaultPlanPromiseRef.current = { resolve, reject };
      queryCheckDefaultPlan({ variables: { countryCode } });
    });

  useEffect(() => {
    if (queryNamePromiseRef.current && !checkNameQueryLoading) {
      if (checkNameQueryError) {
        queryNamePromiseRef.current.reject(checkNameQueryError);
      }
      if (checkNameData) {
        queryNamePromiseRef.current.resolve(checkNameData);
      }
    }
  }, [checkNameQueryLoading]);

  useEffect(() => {
    if (queryCheckDefaultPlanPromiseRef.current && !checkDefaultPlanQueryLoading) {
      if (checkDefaultPlanQueryError) {
        queryCheckDefaultPlanPromiseRef.current.resolve(checkDefaultPlanQueryError);
      }
      if (checkDefaultPlanData) {
        queryCheckDefaultPlanPromiseRef.current.resolve(checkDefaultPlanData);
      }
    }
  }, [checkDefaultPlanQueryLoading]);

  return (
    <CommissionPlanEditorContainer
      activeModal
      t={t}
      type={modalType}
      plan={editPlan}
      handleCloseModal={handleCloseModal}
      handleSubmit={modalType === 'create' ? createPlan : updatePlan}
      handleCheckDefaultPlan={queryCheckDefaultPlanPromise}
      handleCheckDuplicateName={queryDuplicateNamePromise}
    />
  );
};

export default CommissionPlanEditor;
